import './ErrorPage.css';

const Error500 = () => {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="error-page-content">
      <div className="error-content">
        <h1 className="error-code">500</h1>
        <h2 className="error-title">Interná chyba servera</h2>
        <p className="error-message">
          Prepáčte, vyskytla sa neočakávaná chyba. Skúste to prosím neskôr.
        </p>
        <button onClick={handleReload} className="btn btn-primary btn-lg">
          Obnoviť stránku
        </button>
      </div>
    </div>
  );
};

export default Error500;
